/**
 * Feriados e suspensões que o advogado lança na própria conta (docs/PLANO_CONTAGEM_PRAZOS.md, Bloco E):
 * valem só nas contas dele, na hora, e viram sugestão ao calendário oficial.
 */
import type { Justica, RegraForense } from './calendarioForense';
import { api } from './client';

export type SituacaoSugestao = 'pendente' | 'promovida' | 'recusada';

export interface MeuFeriado extends RegraForense {
  sugestao: SituacaoSugestao | null;
  sugestao_nota: string | null;
  regra_oficial_id: string | null;
  created_at: string;
}

export interface LancarFeriadoInput {
  nome: string;
  tipo: 'feriado' | 'suspensao';
  data: string;
  data_fim: string | null;
  abrangencia: 'tribunal' | 'municipal' | 'estadual';
  tribunal: string | null;
  municipio_ibge: number | null;
  uf: string | null;
  /** No município: só nesta justiça (a do processo). */
  justica: Justica | null;
  ato_normativo: string;
  observacao: string | null;
}

/** Onde a conta tem processo (o que se escolhe ao lançar fora de um prazo), com quantos. */
export interface LugaresDoAcervo {
  tribunais: { tribunal: string; justica: Justica | null; processos: number }[];
  comarcas: {
    municipio_ibge: number;
    municipio_nome: string | null;
    uf: string | null;
    justica: Justica;
    /** Os tribunais do acervo com ato neste município, nesta justiça. */
    tribunais: string[];
    processos: number;
  }[];
  ufs: { uf: string; processos: number }[];
}

const BASE = '/prazos/meus-feriados';

export async function fetchMeusFeriados(): Promise<MeuFeriado[]> {
  const { data } = await api.get<MeuFeriado[]>(BASE);
  return data;
}

export async function fetchLugaresDoAcervo(): Promise<LugaresDoAcervo> {
  const { data } = await api.get<LugaresDoAcervo>(`${BASE}/lugares`);
  return data;
}

export async function lancarFeriado(input: LancarFeriadoInput): Promise<MeuFeriado> {
  const { data } = await api.post<MeuFeriado>(BASE, input);
  return data;
}

export async function definirMeuFeriadoAtivo(id: string, ativo: boolean): Promise<MeuFeriado> {
  const { data } = await api.put<MeuFeriado>(`${BASE}/${encodeURIComponent(id)}/ativo`, { ativo });
  return data;
}
